import React, { useState } from 'react'
import "./Reason_cancelling_field_holder.css"
import { Form } from 'react-bootstrap'
import Green_Btn from '../common_btn/green_btn/Green_Btn'
import Gray_Btn from '../common_btn/gray_btn/Gray_Btn'
import Success_Modal from '../common_modal/success_modal/Success_Modal'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { cancelOrder, returnOrder } from '../../../features/order/orderSlice'
import { encodeId } from '../../../utils/common'

function Reason_cancelling_field_holder({
    setCancelReason,
    cancelReason,
    cancelReasonId,
    selectedItems,
    order,
    error,
    setError,
    type,
}) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState(false);
    const handleClick = () => {
        setModalShow(true);
        setTimeout(() => {
            setModalShow(false);
            navigate("/");
        }, 3000);
    };
    const onSubmit = async () => {
        const data = {
            message: cancelReason,
            products: selectedItems,
        };

        console.log(data, '33213data');
        console.log(cancelReason,
            cancelReasonId,
            selectedItems,
            order,
            error,
            setError,
            type,);


        let res;
        if (type === "Return") {
            if (cancelReasonId === null) {
                setError("Return Reason Required");
                return;
            }
            if (selectedItems.length === 0) {
                setError("Select product to cancel this message");
                return;
            }
            data.return_reason_id = cancelReasonId;
            res = await dispatch(returnOrder({ order_id: order?.id, data: data }));
        }

        if (type === "Cancel") {
            if (cancelReasonId === null) {
                setError("Cancel Reason Required");
                return;
            }
            if (selectedItems.length === 0) {
                setError("Select product to cancel this message");
                return;
            }
            data.cancel_reason_id = cancelReasonId;
            res = await dispatch(cancelOrder({ order_id: order?.id, data: data }));
        }
    

        if (res.meta?.requestStatus === "fulfilled") {
            handleClick();

        } else if (res.meta?.requestStatus === "rejected") {
            // Optionally handle error here
        }
    };


    return (
        <>
            <section className='Reason_cancelling_field_holder'>
                <Form>
                    <Form.Group className="input_group  mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>{type === "Cancel"
                            ? "Could you tell us a reason for cancelling? (optional)"
                            : type === "Return"
                                ? "Could you tell us a reason for Returning? (optional)"
                                : ""}</Form.Label>
                        <Form.Control as="textarea"
                            placeholder="Type a reason"
                            rows={1}
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)} />
                    </Form.Group>
                    <p style={{ color: "red" }}>{error}</p>
                    <div className="btn_holder">
                        <Green_Btn btn_name={"Submit"} onClick={() => onSubmit()} />
                        <Green_Btn
                            btn_name={"Cancel"}
                            onClick={() => navigate(`/order-details/${order?.id}`)}
                        />
                    </div>
                </Form>
            </section>
            <Success_Modal
                show={modalShow}
                onHide={() => { setModalShow(false) }}
                successText={
                    type === "Cancel"
                        ? "Order Cancelled Successfully!"
                        : "Order Return Successfully!"
                }
            />
        </>
    )
}

export default Reason_cancelling_field_holder
